const Publications = () => {
//check if page is publications (id 153)
  if (document.querySelector('.page.page-id-153')) {

    let selectedProduct = null;
    let selectedKeywords = [];
    let publicationData = null;
    let productData = null;

    //get publication data
    if (sessionStorage.getItem('publicationData') === null) {
      //if publication data is not in session storage, fetch it
      fetch('/api/mira/v1/publications')
        .then(response => response.json())
        .then(data => {
          publicationData = data;
          sessionStorage.setItem('publicationData', JSON.stringify(publicationData));
        });
    } else {
      //if publication data is in session storage, get it
      publicationData = JSON.parse(sessionStorage.getItem('publicationData'));
    }

    //get product data
    if (sessionStorage.getItem('productData') === null) {
      // if product data is not in session storage, fetch it
      fetch('/api/mira/v1/products')
        .then(response => response.json())
        .then(data => {
          productData = data;
          sessionStorage.setItem('productData', JSON.stringify(productData));
        });
    } else {
      //if product data is in session storage, get it
      productData = JSON.parse(sessionStorage.getItem('productData'));
    }


    /*
    Event Listeners
    */

    //dropdown item selected
    document.querySelectorAll('ul.dropdown-menu li').forEach(el => {
      el.addEventListener('click', function () {
        //get data-option value and set as selectedProduct
        selectedProduct = el.getAttribute('data-option').toLowerCase();

        //set dropdown button text
        document.querySelector('.dropdown-toggle span').innerHTML = el.innerHTML;

        //get the selected data from productData
        const product = productData.filter(el => {
          return el.name.toLowerCase() === selectedProduct;
        });

        const uppercaseName = product[0].name.toUpperCase();

        //set the selected product title and PI button link
        document.querySelector('[data-obj="name"] p').innerHTML = `
         <span>${uppercaseName}<sup>&reg;</sup></span>
         <span>(${product[0].medication_generic_name}) ${product[0].medication_delivery_method}</span>
           `;

        document.querySelectorAll('[data-widget="pi-button"]').forEach(el => {
          el.innerHTML = `
            <a target="_blank" href="${product[0].url}">
                <button class="btn btn-primary" type="button">Full Prescribing Information</button>
            </a>
         `;
        })


        //render publications
        renderPublications();
      });
    });

    //keyword apply button pressed
    document.querySelector('#button-apply').addEventListener('click', () => applyKeyword());
    document.querySelector('#button-apply-mobile').addEventListener('click', () => applyKeyword(true));

    //keyword clear all button pressed
    document.querySelector('#button-clear').addEventListener('click', function () {
      removeKeyword(null);
      renderPublications();
    });

    document.querySelector('#button-clear-mobile').addEventListener('click', function () {
      removeKeyword(null);
      renderPublications();
    });

    //mobile - open filter modal
    document.querySelector('[data-obj="filter"]').addEventListener('click', function () {
      document.querySelector('[data-widget="modal-filter-by-keyword"]').style.display = "block";
    });

    //mobile - close filter modal
    document.querySelector('[data-action="exit"]').addEventListener('click', function () {
      document.querySelector('[data-widget="modal-filter-by-keyword"]').style.display = "none";
    });


    /*
    Functions
    */

    function applyKeyword(isMobile) {
      //apply keyword
      const keywordBox = document.querySelector(`#keyword-input${isMobile ? "-mobile" : ""}`);
      if (keywordBox.value !== "") {
        selectedKeywords.push(keywordBox.value.toLowerCase());

        console.log({
          event : 'PubKeyword',
          eventModel: {
            q_Keyword : keywordBox.value.toLowerCase(),
            q_Product : (function(){
              var e = document.querySelector('[data-widget="search-pubs"] .dropdown-toggle .dropdown-item strong'),
                  t = e ? e.textContent : '';

              return t
              })(),
            }
          });

        dataLayer.push({
          event : 'PubKeyword',
          eventModel: {
            q_Keyword : keywordBox.value.toLowerCase(),
            q_Product : (function(){
              var e = document.querySelector('[data-widget="search-pubs"] .dropdown-toggle .dropdown-item strong'),
                  t = e ? e.textContent : '';

              return t
              })(),
            }
          });

        keywordBox.value = '';
        renderKeywords();

        //render publications
        renderPublications();
      }
    }

    function removeKeyword(keyword) {
      //if keyword is null, remove all keywords
      if (keyword === null) {
        selectedKeywords = [];
        renderKeywords();
      } else {
        //remove keyword from array
        selectedKeywords = selectedKeywords.filter(el => {
          return el !== keyword;
        });
        renderKeywords();
      }
      renderPublications();
    }

    function renderKeywords() {
      //render keywords in keyword box
      document.querySelectorAll('[data-obj="words"]').forEach(keywordContainer => {
        keywordContainer.innerHTML = "";
        selectedKeywords.forEach(keyword => {
          const keywordEl = document.createElement('button');
          ["btn", "mt-3", "me-1"].forEach(item => keywordEl.classList.add(item));
          keywordEl.innerHTML = keyword;
          keywordEl.addEventListener('click', () => removeKeyword(keyword));
          keywordContainer.appendChild(keywordEl);
        });
      });
    }

    function renderPublications() {
      //render publications array using filters
      const publicationContainer = document.querySelector('[data-obj="pubs"]');
      publicationContainer.innerHTML = "";
      publicationData.forEach(publication => {
        let productMatch = false, keywordMatch = false;

        //check if publication matches selected product
        publication.associated_products.forEach(product => {
          if (product.name.toLowerCase() === selectedProduct) {
            productMatch = true;
          }
        });

        //check if publication keywords match selected keywords
        publication.keywords.forEach(keyword => {
          if (keyword === null) return;
          //lowercase keyword
          keyword = keyword.toLowerCase();
          if (selectedKeywords.includes(keyword)) {
            keywordMatch = true;
          }
        });

        //if no keywords selected, set keywordMatch to true
        if (selectedKeywords.length === 0) {
          keywordMatch = true;
        }

        //if product and keyword match, render publication
        if (productMatch && keywordMatch) {
          renderPublication(publication);
        }
      });

      //update publication count
      setTimeout(() => {
        document.querySelectorAll('[data-obj="info-counter"] p').forEach(el => {
          el.innerHTML = `Results (${publicationContainer.childElementCount})`;
        });
      }, 100);
    }

    function renderPublication(publication) {
      //render publication using template
      const publicationContainer = document.querySelector('[data-obj="pubs"]');
      const publicationEl = document.createElement('div');

      const authors = () => {
        //if authors list is more than 3, show "et al."
        if (publication.authors.length > 3) {
          return `${publication.authors[0]}, ${publication.authors[1]}, ${publication.authors[2]}, et al.`;
        } else {
          return publication.authors.join(", ");
        }
      }

      publicationEl.innerHTML = `
        <div class="card mb-4">
          <div class="card-body d-md-flex">
            <div class="align-items-center col-12 col-md-9">
              <h1>${publication.associated_products[0].name.toUpperCase()}<sup>&reg;</sup></h1>
              <h2>${publication.title}</h2>
              <h3>${new Date(publication.publication_date).getFullYear()}</h3>
              <h4>${authors()}</h4>
            </div>
            <div class="d-md-flex align-items-center col-12 col-md-3">
              <a target="_blank" href="${publication.url}">
                <button class="btn" type="button" data-action="view">
                  <span>View</span>
                </button>
              </a>
            </div>
          </div>
        </div>
      `;
      publicationContainer.appendChild(publicationEl);
    }


  }

};

export default Publications;
